import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Input from "../../components/Input";
import { NavLink, useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "../../apis/loginApis";
import toast from "react-hot-toast";

type Props = {};

const ForgotPasswordSaudi = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isPending, isSuccess } = useResetPasswordMutation();

  const submitData = async (data: any) => {
    mutate(
      { ...data, type: "outlet" },
      {
        onSuccess: (data) => {
          toast.success(data?.message);
          setTimeout(() => {
            navigate("/");
          }, 1000);
        },
        onError: (error) => {
          toast.error(`${error}`);
        },
      },
    );
  };

  return (
    // <div className="flex items-center justify-center ">
    //   <div className="w-full ">
    //       <div className="flex justify-center items-center">
    //         <div className="space-y-4">
    //           <div>
    //             <h2 className="text-3xl font-medium text-center">
    //               {t("Forgot Your Password")}
    //             </h2>
    //             <p className="text-[#000000]/70">
    //               Please Enter Your Email For Reset Password !
    //             </p>
    //           </div>
    //           <form
    //             className="space-y-4"
    //             id="loginForm"
    //             onSubmit={handleSubmit(submitData)}
    //           >
    //             <div className=" text-left space-y-1">
    //               <Input
    //                 name="email"
    //                 type="text"
    //                 title="Email"
    //                 placeholder="Enter Your Email"
    //                 register={register}
    //                 error={errors.email}
    //                 validation={{
    //                   required: "Email is required",
    //                   pattern: {
    //                     value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    //                     message: "Please enter a valid email address",
    //                   },
    //                 }}
    //               />
    //             </div>

    //             <button
    //               type="submit"
    //               disabled={isPending || isSuccess}
    //               className={`w-full flex justify-center items-center gap-2 font-semibold py-3 rounded-full transition
    // ${
    //   isPending
    //     ? "bg-gray-800 cursor-not-allowed text-[#ffffff]"
    //     : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
    // }
    // `}
    //             >
    //               {isPending ? (
    //                 <>
    //                   <svg
    //                     className="animate-spin h-5 w-5 text-white"
    //                     xmlns="http://www.w3.org/2000/svg"
    //                     fill="none"
    //                     viewBox="0 0 24 24"
    //                   >
    //                     <circle
    //                       className="opacity-25"
    //                       cx="12"
    //                       cy="12"
    //                       r="10"
    //                       stroke="currentColor"
    //                       strokeWidth="4"
    //                     />
    //                     <path
    //                       className="opacity-75"
    //                       fill="currentColor"
    //                       d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
    //                     />
    //                   </svg>
    //                   Sending Reset Link...
    //                 </>
    //               ) : (
    //                 "Forgot Password"
    //               )}
    //             </button>
    //             <p className="text-center">
    //               Back To{" "}
    //               <NavLink to="/" className="text-[#1a73e8] underline ">
    //                 Login
    //               </NavLink>
    //             </p>
    //           </form>
    //         </div>
    //       </div>
    //   </div>
    //   <div className=" w-full">
    //     <img src="/img/login-screen.svg" alt="" className="w-fit" />
    //   </div>
    // </div>

    <div className="flex items-center justify-center h-screen  bg-gradient-to-l from-[#FFE783] to-[#E4E5E7]">
      <div className=" w-[40%] relative h-full flex justify-center items-center ">
        <div className="flex flex-col items-center gap-6">
          {/* <div className="flex justify-center">
                <LanguagePicker />
              </div> */}
          <div className="space-y-8 p-6   2xl:w-[28rem] lg:w-[26rem] w-full">
            <div className="flex justify-start">
              <img
              src="/logo/logo-black.png"
                alt="Logo"
                className="2xl:w-60 w-52"
              />
            </div>

            <div className="text-left">
              <h2 className="2xl:text-3xl text-2xl font-medium ">
                {t("Forgot Your Password")}
              </h2>
              <p className="text-[#000000]/70 2xl:text-base text-sm">
                Please Enter Your Email For Reset Password !
              </p>
            </div>
            <form
              className="space-y-4"
              id="loginForm"
              onSubmit={handleSubmit(submitData)}
            >
              <div className=" text-left space-y-1">
                <Input
                  name="email"
                  type="text"
                  title="Email"
                  placeholder="Enter Your Email"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.email}
                  validation={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isPending || isSuccess}
                className={`w-full flex justify-center items-center gap-2 font-semibold py-3 rounded-lg transition ${
                  isPending
                    ? "bg-[#212121] cursor-not-allowed text-[#ffffff]"
                    : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
                }`}
              >
                {isPending ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                      />
                    </svg>
                    Sending Reset Link...
                  </>
                ) : (
                  "Forgot Password"
                )}
              </button>
              <p className="text-center">
                Back To{" "}
                <NavLink to="/" className="text-[#1a73e8] underline ">
                  Login
                </NavLink>
              </p>
            </form>
          </div>
        </div>
      </div>
      <div className="w-[60%] h-full flex justify-end relative bg-cover overflow-hidden">
        <img
        src="/logo/outlet-login-image.png"
          className="w-10/12 "
          alt="login-screen"
        />
      </div>
    </div>
  );
};

export default ForgotPasswordSaudi;
